import { render, staticRenderFns } from "./DefiBorrowConfirmation.vue?vue&type=template&id=56f20ecf&"
import script from "./DefiBorrowConfirmation.vue?vue&type=script&lang=js&"
export * from "./DefiBorrowConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports